import { useTranslation } from "react-i18next";
import { MotionItem, MotionReveal, MotionStagger } from "./MotionReveal";

export function Ecosystem() {
  const { t } = useTranslation("global");
  const items = t("ecosystem.items", { returnObjects: true });

  return (
    <section className="siat-section" id="ecosystem">
      <div className="siat-wrap">
        <MotionReveal className="siat-intro siat-intro--center">
          <p className="siat-eyebrow">{t("navigation.ecosystem")}</p>
          <h2>{t("ecosystem.title")}</h2>
          <p className="siat-lead">{t("ecosystem.subtitle")}</p>
        </MotionReveal>

        <MotionStagger className="siat-eco-grid">
          {Array.isArray(items) &&
            items.map((item, index) => (
              <MotionItem as="article" key={item.title} className="siat-eco-card">
                <span aria-hidden="true">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </MotionItem>
            ))}
        </MotionStagger>
      </div>
    </section>
  );
}
